module.exports = __webpack_public_path__ + "static/media/croquis_02.bff2a3b4.jpg";